export enum  ChangeOrderTemplateEnum
{
    Category = 'CHO'
}
